import { langType } from './lang-base';

export const lang: langType = {
  title: 'VUE H5 development template',
  tabbar: {
    home: 'Home',
    list: 'List',
    member: 'Member',
    demo: 'demo',
  },
  language: {
    en: 'English',
    zh: 'Chinese',
  },
  introduction: 'A rapid development vue3 of mobile terminal template',
  home: {
    support: 'support',
    cssMultiLanguage: 'CSS picture multi-language',
  },
  list: {
    details: 'list details',
  },
  btn: {
    confirm: 'confirm',
    cancel: 'cancel',
  },
  member: {
    nicknamePlaceholder: 'Nickname',
    contactLabel: 'Contact: ',
    contactFallback: 'Other personal info, to be added...',
    changePassword: 'Change Password',
    uploadAvatar: 'Upload Avatar',
    logs: 'Logs',
    logout: 'Logout',
    logoutQuestion: 'Are you sure you want to log out?',
    cancel: 'Cancel',
    fetchUserInfoFailed: 'Failed to fetch user info',
    fetchUserInfoError: 'Error fetching user info',
  },
  common: {
    and: 'and',
    agreePolicy: 'Agree to Policy',
    rememberPassword: 'Remember Password',
    // 认证页面共用文本
    phoneLabel: 'Phone Number',
    phonePlaceholder: 'Please enter phone number',
    passwordLabel: 'Password',
    passwordPlaceholder: 'Please enter password',
    agreement: 'I have read and agree to',
    userAgreement: 'User Agreement',
    privacyPolicy: 'Privacy Policy',
    phoneRequired: 'Please enter phone number',
    passwordRequired: 'Please enter password',
    passwordLength: 'Password length should be 6-20 characters',
    confirmPasswordLabel: 'Confirm Password',
    confirmPasswordPlaceholder: 'Please enter confirm password',
    confirmPasswordRequired: 'Please confirm password',
    passwordNotMatch: 'Passwords do not match',
    agreementRequired: 'Please agree to the User Agreement and Privacy Policy first',
    loading: 'Logging in...',
    // 验证码相关
    verificationCodePlaceholder: 'Please enter verification code',
    getVerificationCode: 'Get Code',
    verificationCodeRequired: 'Please enter verification code',
    verificationCodeInvalid: 'Invalid verification code format',
    copyright: '© 2025 D3 Technology Support',
    appTitle: 'Management System',
    loadingInProgress: 'Loading',
    loginExpired: 'Login expired, please login again',
    menuLoadFailed: 'Failed to load menu, please login again',
    loadingStart: 'Starting...',
    prepareMenu: 'Preparing to fetch menu',
    menuLoaded: 'Menu: loaded',
    themeUpdated: 'Theme: updated',
    baseDataLoaded: 'Base data: loaded',
    serviceDictLoaded: 'Service dictionary: loaded',
    nativeSyncConfig: 'Native: syncing startup config',
    titleLoading: 'Loading title',
    loadingDomain: 'Domain: {host}',
    loadingRequestUrl: 'Request: {url}',
    loadingProtocol: 'Protocol: {protocol}',
    loadingLoginAddress: 'Login address: {url}',
    loadingLoginUrl: 'Login URL: {url}',
  },
  login: {
    title: 'Login',
    accountPlaceholder: 'Phone',
    passwordPlaceholder: 'Password',
    rememberMe: 'Remember Account',
    rememberAccount: 'Remember Account',
    forgotPassword: 'Forgot Password?',
    loginButton: 'Login',
    loggingIn: 'Logging in...',
    loginSuccess: 'Login Success',
    otherLogin: 'Other Login Methods',
    switchLanguage: 'Chinese',
    switchLanguageEn: 'English',
    tenantTitle: 'Please select a tenant',
    noAccount: "Don't have an account?",
    signUp: 'Sign up',
    register: 'Sign up',
    loginFailed: 'Login failed, incorrect username or password',
    phoneRequired: 'Please enter account',
    passwordRequired: 'Please enter password',
    passwordLength: 'Password length should be 2-20 characters',
  },
  register: {
    title: 'Register',
    accountPlaceholder: 'Phone',
    usernamePlaceholder: 'Please enter username',
    phoneCorrect: 'Correct phone number',
    phonePlaceholder: 'Please enter phone number',
    passwordPlaceholder: 'Please enter login password',
    confirmPlaceholder: 'Please confirm password',
    confirmPasswordPlaceholder: 'Please confirm password',
    captchaPlaceholder: 'Please enter image captcha',
    smsCodePlaceholder: 'Please enter SMS code',
    registerButton: 'Register',
    registering: 'Registering...',
    registerSuccess: 'Register Success',
    hasAccount: 'Already have an account?',
    loginButton: 'Login',
    backToLogin: 'Back to Login',
    sendCode: 'Send Code',
    codeSent: 'Code sent',
    sendFailed: 'Send failed',
    smsSent: 'SMS code sent',
    smsFailed: 'Failed to send SMS',
    accountRequired: 'Please enter account',
    usernameRequired: 'Please enter username',
    phoneRequired: 'Please enter phone number',
    captchaRequired: 'Please enter image captcha',
    smsCodeRequired: 'Please enter SMS code',
    passwordRequired: 'Please enter password',
    passwordTooShort: 'Password must be at least 6 characters',
    passwordMismatch: 'Passwords do not match',
    success: 'Register Success',
    failed: 'Register Failed',
  },
  forgotPassword: {
    title: 'Reset Password',
    phonePlaceholder: 'Please enter phone number',
    codePlaceholder: 'Please enter verification code',
    captchaPlaceholder: 'Please enter image captcha',
    smsCodePlaceholder: 'Please enter SMS code',
    newPasswordPlaceholder: 'Please enter new password',
    confirmPasswordPlaceholder: 'Please enter new password again',
    nextStep: 'Next',
    confirmReset: 'Confirm',
    resetting: 'Submitting...',
    resetSuccess: 'Reset Success',
    subtitle: 'Please enter your phone number and reset your new password',
    resetButton: 'Reset Password',
    hasAccount: 'Remember password?',
    loginButton: 'Login',
    codeSent: 'Code sent',
    sendFailed: 'Send failed',
    sendCode: 'Send Code',
    captchaRequired: 'Please enter image captcha',
    passwordEmpty: 'New password cannot be empty',
    resetFailed: 'Reset failed',
    cancel: 'Cancel',
  },
  changePassword: {
    title: 'Change Password',
    currentPassword: 'Please enter current password',
    newPassword: 'Please enter new password',
    confirmPassword: 'Please again enter the new password',
    updateFailed: 'Failed to change password, please retry',
  },
  hotUpdate: {
    writePermissionDenied: 'Unable to write to the update directory. Please allow file access for this app in system settings, then retry the hot update.',
    storagePermissionPurpose: 'When a new version is detected, the app needs storage access to download the update package locally and complete installation on the next restart.\nWe only save update files to the app\'s update directory and do not read your photos, videos, or other personal files.\nIf you deny this permission, the current hot update cannot continue, but the basic app functions will still work.',
    storagePermissionApplying: 'Requesting storage access and creating the local update directory. Please wait.',
    updatePromptTitle: 'Update Available',
    newVersionFound: 'New version found {version}',
    currentVersion: 'Current version: {version}',
    updateDescription: 'Update notes:',
    confirmSwitchTitle:'Confirm Switch Version',
    confirmSwitchMsg:'Confirm to switch to version ?',
    restartWarning:'The app will restart to complete the update',
    restartingUpdateToast:'Restarting the app to apply the update, please wait…',
    updatedToast:'Updated to latest version {version}',
    currentVersionhis:'Current version in use',
    retry: 'Retry',
    downloadFailedTitle: 'Download Failed',
    downloadFailed: 'Failed to download the update package. Please retry.',
    downloadTimeout: 'Download timed out. Please check your network and retry.',
    downloadNetworkError: 'Network error. Please check your connection and retry.',
    downloadNotFound: 'Download URL is unavailable. Please retry later.',
    downloadNoSpace: 'Not enough storage. Please free up space and retry.',
    downloadStalled: 'No download progress detected. Please retry.'
  },
  uploadAvatar: {
    title: 'Upload Avatar',
    upload: 'Upload',
    remove: 'Remove',
    rechoose: 'Rechoose',
    choose: 'Choose',
    uploading: 'Uploading avatar...',
    uploadSuccess: 'Avatar uploaded successfully!',
    uploadFailed: 'Avatar upload failed!',
    uploadError: 'Avatar upload error',
    fileTooLarge: 'File size cannot exceed 5MB',
    removed: 'Avatar removed',
  },
  logs: {
    needsenabled: 'Storage permission required',
    storagePermissionMessage:'Enable storage permission so logs can be saved locally and exported later.',
    enableStorage: 'Enable',
    storagePermissionDialogTitle: 'Enable storage permission',
    storagePermissionLater: 'Not now',
    storagePermissionDialogBody:
      'With storage permission enabled, you can save and export logs. Without it, logging features will be limited.',
    noLogs: 'No logs',
    title: 'Application log',
    viewRange: 'View Range',
    refresh: 'Refresh',
    export: 'Export',
    clear: 'Clear',
    all: 'All',
    error: 'Error',
  },
  adpage: {
    skip: 'Skip',
  },
  serve: {
    title: 'Proxy Settings',
    current: 'Current Server',
    select: 'Select Server',
    back: 'Back',
    placeholder: 'Please input the server address',
    pleaseinput: 'Please input the server name',
    notset: 'Not set',
    testlink: 'Connection Test',
    testSuccess: 'Connection Successful',
    testFail: 'Connection Failed',
    timeoutRetry: 'Request timed out, please retry',
    fetchSuccess: 'Server address fetched successfully',
    setSuccess: 'Server set successfully',
    timeout: 'Request timed out',
    requestFailedCheckAddress: 'Request failed, please check the address',
    addressIncorrect: 'Server address is incorrect',
    invalidAddressFormat: 'Invalid address format, please check'
  },
  indexPage: {
    slogan: 'Efficient Collaboration',
    sloganDesc: 'Connect team resources, fully enhance management execution',
    noAccount: "Don't have an account?",
    applyAccount: 'Sign Up',
    hasAccount: 'Already have an account?',
    loginNow: 'Login Now',
    rememberPassword: 'Remember password?',
    goLogin: 'Go Login',
  },
  exited: {
    toastMessage: 'Swipe again to exit the app'
  }
};